module.exports = "/_next/static/images/mokubaza-appearance-76dac1e55e40b7d4e2fa73b767bf155f.png";